<template>
    <div>
        <div v-if="!this.$store.state.display_kit_instruction" class="general-active-section" :class="validatedSectionClass">
            <div class="row">
                <div class="col-md-10 col-md-offset-1">
                    <br><br>
                    <div class="form-group">
                        <el-button icon="el-icon-camera-solid" class="w-100 secondary-color secondary-border" @click="drawer=true"><span>{{computeCaption(fields_en['scan_barcode'], this.$store.state.lang.value.toLowerCase())}}</span></el-button>
                        <el-drawer
                            :with-header="false"
                            :append-to-body="true"
                            :visible.sync="drawer"
                            direction="ltr"
                            size="100%"
                        >
                            <HomekitScanner v-on:closeScanner="closeScanner" v-on:getScannedData="getScannedData"/>
                        </el-drawer>
                    </div>
                </div>
                <div class="col-md-10 col-md-offset-1 text-center red">
                  {{computeCaption(fields_en['input_kit_number'], this.$store.state.lang.value.toLowerCase())}}
                </div>
                <div>
                    <div class="col-md-10 col-md-offset-1">
                        <div class="form-group">
                            <label class="control-label" for="kit_number">
                              {{computeCaption(fields_en['kit_number'], this.$store.state.lang.value.toLowerCase())}}
                            </label>
                            <input class="form-control"
                                id="kit_number"
                                type="text"
                                data-vv-as="Kit Number"
                                name="kit_number"
                                v-model="model.kit_number"
                                placeholder="888 888"
                                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                            />

                        </div>
                    </div>
                    <div class="form-group">
                        <small class="col-md-10 col-md-offset-1 text-danger" v-show="kit_error">
                          {{kit_error && computeCaption(kit_error, this.$store.state.lang.value.toLowerCase())}}
                        </small>
                    </div>
                </div>
            </div><br><br>
            <button :disabled="disabled" class="btn btn-info btn-fill btn-wd btn-submit f-right submit-button mt-10" @click="submit"><span> {{buttonText && computeCaption(buttonText, this.$store.state.lang.value.toLowerCase())}}</span></button>
        </div>
        <div v-else>
            <div class="row">
                <div class="form-group text-center">
                    <br><div class="col-md-10 col-md-offset-1" v-html="this.$store.state.kit.kit_instruction"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import swal from 'sweetalert2'
  import axios from 'axios'
  import HomekitScanner from './dynamo/HomekitScanner'
  import { Drawer, Button } from 'element-ui'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  export default {
    components: {
      HomekitScanner,
      [Drawer.name]: Drawer,
      [Button.name]: Button
    },
    mixins: [TranslationsUtils],
    data () {
      return {
        kit_error: '',
        buttonText: 'Save Kit Number',
        validatedSectionClass: '',
        disabled: false,
        drawer: false,
        fields_en: {
          kit_number: 'Kit Number',
          scan_barcode: 'Scan Barcode on Tube',
          input_kit_number: 'Or Input the Kit Number'
        },
        model: {
          kit_number: ''
        },
        modelValidations: {
          kit_number: {
            required: true,
            max: 25
          }
        }
      }
    },
    methods: {
      closeScanner () {
        this.drawer = false
      },
      getScannedData (data) {
        this.drawer = false
        this.model.kit_number = data
      },
      async submit () {
        const self = this
        if (this.model.kit_number && this.model.kit_number.length <= this.modelValidations.kit_number.max) {
          this.kit_error = ''
          this.disabled = true
          this.buttonText = 'Submitting.. Please wait'
          await axios.post(process.env.SERVER_URI + '/submit/kit/' + this.$store.state.kit.site_code, { kit_number: this.model.kit_number, userData: this.$store.state.kit.userData })
          .then((response) => {
            if (response.data === true) {
              self.$store.state.display_kit_instruction = true
              this.buttonText = 'Save Kit Number'
              this.disabled = false
              this.model.kit_number = ''
            } else {
              swal('Error!', 'Something went wrong! <br>' + response.data.error, 'error')
              this.disabled = false
              this.buttonText = 'Save Kit Number'
            }
          }).catch(() => {
            self.redirect()
            swal('Error!', 'Something went wrong! <br> We could not register your kit number!', 'error')
          })
        } else {
          if (this.model.kit_number.length > this.modelValidations.kit_number.max) {
            this.kit_error = 'The field has a maximum of ' + this.modelValidations.kit_number.max + ' characters'
          } else {
            this.kit_error = 'Please Scan your kit number'
          }
          document.getElementsByName('kit_number')[0].focus()
        }
      },
      redirect () {
        const body = document.querySelector('body')
        const self = this
        body.onclick = function () {
          self.$router.push({ path: '/' })
          window.location.reload()
        }
      }
    },
    watch: {
      'model.kit_number': {
        handler: function (after, before) {
          if (this.model.kit_number && this.model.kit_number.length <= this.modelValidations.kit_number.max) {
            this.validatedSectionClass = 'validated-section-class'
            this.kit_error = ''
          } else {
            if (this.model.kit_number.length > this.modelValidations.kit_number.max) {
              this.kit_error = 'The field has a maximum of ' + this.modelValidations.kit_number.max + ' characters'
            } else {
              this.kit_error = 'Please Scan your kit number'
            }
            this.validatedSectionClass = 'invalid-section-class'
          }
        }
      }
    }
  }
</script>

<style scoped>
  .w-100{
    width: 100%;
  }

  .scan-button{
    font-size: 17px;
    background: white;
    border-radius: 5px;
  }

  .f-right{
    float: right;
  }

  .mt-10{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RegistrationKit/Wizard/ScanKit.vue